import { API_BASE_URL } from './config';

export const getRepairImageUrl = (imageUrl?: string): string | null => {
  if (!imageUrl) return null;
  return `${API_BASE_URL}${imageUrl}`;
};

// Returns the delivery note image URL for a shipping record
export const getDeliveryNoteImageUrl = (shippingRecordId: number): string => {
  return `${API_BASE_URL}/shipping/${shippingRecordId}/delivery-note-image`;
};
